import { GeofenceService } from '@/app/geofence/services/geofence.service'
import { geofenceModel } from '@/app/geofence/models/geofence.model'
import { getOwners, getGroups, getContracts, getDistricts, getCategoriesBy, getGeofenceGeneralTypes} from '@/app/share/lists'


const initialState = () => ({
    loading: false,
    errors: null,
    typesOptions: [],
    ownersOptions: [],
    groupsOptions: [],
    contractsOptions: [],
    categoriesOptions: [],
    geofenceTypesOptions:[],
    districtOptions:[],
    filteredDistrictOptions:[],
    cityFilterOptions:[],
    cityFilter:null,
    data:  Object.assign({}, geofenceModel)
  })

const state = initialState()

const mutations = {

  updateRoot(state, payload){
    state.root = payload
  },

  /** reinit state */
  INIT_STATE (state) {
    const model = Object.assign({}, geofenceModel)
    Object.assign(state, {
      loading: false,
      errors: null,
      data: {
        ...model,
        attributes: [],
      },
    });
  },

  /** geofence data request */
  GEOFENCE_DATA_REQUEST (state) {
    Object.assign(state, { loading: true, errors: null });
  },

  SET_GEOFENCE_TYPES_OPTIONS(state, payload) {
    Object.assign(state, {
      geofenceTypesOptions: payload
    });
  },
  /** geofence data success */
  GEOFENCE_DATA_SUCCESS (state, payload) {
    Object.assign(state, { loading: false, data: payload });
  },

  /** geofence data error */
  GEOFENCE_DATA_ERROR (state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      errors: payload || true
    });
  },

  /** owners data  */
  SET_OWNERS (state, payload) {
    Object.assign(state, {
      ownersOptions: payload
    });
  },

  /** types data  */
  SET_TYPES (state, payload) {
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      typesOptions: payload
    });
  },

  /** groups data  */
  SET_GROUPS (state, payload) {
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      groupsOptions: payload
    });
  },

  /** categories data  */
  SET_CATEGORIES (state, payload) {
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      categoriesOptions: payload,
      requestsCount: requests_count
    });
  },

  /** contracts data  */
  SET_CONTRACTS (state, payload) {
    const requests_count = state.requestsCount - 1
    Object.assign(state, {
      contractsOptions: payload,
      requestsCount: requests_count
    });
  },

  /** reset geofence data */
  GEOFENCE_DATA_RESET (state) {
    Object.assign(state, ...initialState);
  },

  /** reset geofence data */
  SET_REQUESTS_COUNT (state, count) {
    Object.assign(state, {
      requestsCount: count
    });
  },


  /**   */
  SET_ATTRIBUTES (state, attrs) {
    Object.assign(state.data, {
      attributes: attrs
    });
  },


  UPDATE_AREA (state, area) {
    Object.assign(state, {
      data: Object.assign(state.data, {
        area: area
      })
    });
  },
  updateDistrictOptions (state, payload) {
    state.districtOptions = payload.districts
  },
  updateCityFilterOptions (state, payload) {
    state.cityFilterOptions = payload.districts
  },
  updateCityFilter(state, payload){
    state.cityFilter = payload.value
  },
  filterDistricts(state){
    state.filteredDistrictOptions = state.districtOptions.filter((d) => d.city == state.cityFilter)
  },
  resetCityFilter(state){

    var district = state.districtOptions.filter((option)=> option.id == state.data.district_id)

    if(district.length > 0){
      state.cityFilter = district[0].city
    }
      

  },
  updateDistrictId(state, payload){
    state.data.district_id = payload.value
  }

};



const actions = {

  

  /** fetch geofence data */

  async fetchGeofenceData(context, id) {
    context.commit('GEOFENCE_DATA_REQUEST');
    const result = await GeofenceService.getGeofenceById(id).catch(e => {
      context.commit('GEOFENCE_DATA_ERROR', e);
    });

    if (result) {

      // console.log('geofence result is ',result)
      //  set types options
       GeofenceService.getGeofenceTypesByCategory(result.category).then( response => {
        context.commit('SET_GEOFENCE_TYPES_OPTIONS', response.data.types.data);
      }).catch(e=>console.log(e))
      context.commit('GEOFENCE_DATA_SUCCESS', result);
      context.commit('resetCityFilter')
      context.commit('filterDistricts')
      await context.dispatch('prepareAttributes')

      //await context.dispatch('fetchTypesByCategory', context.state.data.category)
    }

    return result;
  },


  async fetchAllGeofences(context) {
    return new Promise((resolve, reject) => {
      GeofenceService.getAllGeofence().then(r => resolve(r))
        .catch(e => reject(e));
    })
  },


  /** fetch all lists */
  async fetchLists(context, authId) {
    getGroups({user: authId}).then(r => context.commit('SET_GROUPS', r.data.data))
    getContracts({user: authId}).then(r => context.commit('SET_CONTRACTS', r.data.data))
    getOwners({user: authId}).then(r => context.commit('SET_OWNERS', r.data.data))
    getCategoriesBy({type: 'geofence'}).then(r => context.commit('SET_CATEGORIES', r.data.data))
    getDistricts().then(r => {
      context.commit('updateDistrictOptions', {
        districts:r.data.districts.data.map(d=>({id:d.id,city:d.city,name:context.getters.root.$i18n.t(d.name)}))
      })
      context.commit('updateCityFilterOptions', {
        districts:r.data.districts.data.map(c => c.city)
        .filter((value, index, array) => array.indexOf(value) === index)
        .map(c=>({id:c,name:context.getters.root.$i18n.t(c)}))
      })
      context.commit('resetCityFilter')
      context.commit('filterDistricts')
    })
   // getGeofenceGeneralTypes().then(r => context.commit('SET_TYPES', r.data.types.data))
  },
  async fetchGeofenceTypesOptions(context, cat) {
    const types = await getGeofenceGeneralTypes()
    console.log('types',types)
    context.commit('SET_TYPES', types.data.data)
  },

///  fetch geofenceTypes or slug by cat
  async getGeofenceTypesByCategory(context, cat) {
    //context.commit('SET_GEOFENCE_TYPES_OPTIONS', []);
    return new Promise((resolve, reject) => {
      GeofenceService.getGeofenceTypesByCategory(cat)
        .then(r => resolve(r))
        .catch(e => reject(e));
    })
  },


  prepareAttributes(context) {
    const attr = context.state.data.attributes
    context.state.data.attributes = []

    let x = 0
    for (const i in attr) {
      context.state.data.attributes.push({
        id: x++,
        key: i,
        value: attr[i]
      })
    }
  },
  clearForm(ctx) {
    ctx.commit('INIT_STATE')
  },


  updateAttributes(ctx, attrs) {
    ctx.commit('SET_ATTRIBUTES', attrs)
  },


  async createGeofence(context) {
    return new Promise((resolve, reject) => {
      context.commit('GEOFENCE_DATA_REQUEST')
      const geofenceData = context.state.data
      GeofenceService.createGeofence(geofenceData).then(res => {
        context.commit('GEOFENCE_DATA_REQUEST')
        context.commit('INIT_STATE')
        resolve(res)
      }).catch(reason => {
        context.state.loading = false
        if (reason.status === 422) {
          context.state.errors = reason.data.errors
        }
      })
    })
  },


  async updateGeofence(context) {
    return new Promise((resolve, reject) => {
      context.commit('GEOFENCE_DATA_REQUEST')
      const geofenceData = context.state.data
      GeofenceService.updateGeofence(geofenceData.id, geofenceData).then(res => {
        context.state.loading = false
        resolve(res)
      }).catch(reason => {

        reject(reason)
        context.state.loading = false
        if (reason.status === 422) {
          context.state.errors = reason.data.errors
        }
      })
    })
  },



  async deleteGeofence(context, id) {
    return new Promise((resolve, reject) => {
      GeofenceService.deleteGeofence(id).then(res => {
        resolve(res.data)
      })
    })
  }
};

const getters = {
  root(state){
    return state.root
  },
  filteredDistrictOptions(state){
    return state.filteredDistrictOptions
  },
  districtId(state){
    return state.data.district_id
  },
  cityFilterOptions(state){
    return state.cityFilterOptions
  },
  cityFilter(state){
    return state.cityFilter
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
